import { Command } from '@ckeditor/ckeditor5-core';
import ResumeExampleModal from './resume-example-modal';
export default class InsertResumeExampleCommand extends Command {
    execute() {
        try {
            const resumeExampleModal = new ResumeExampleModal();
            resumeExampleModal
                .show()
                .then((resumeExample) => {
                this.editor.model.change((writer) => {
                    this.editor.model.insertContent(createResumeExample(writer, resumeExample));
                });
            })
                .catch(() => { });
        }
        catch (error) {
            console.error(error);
        }
    }
    refresh() {
        this.isEnabled = true;
    }
}
function createResumeExample(writer, resumeExample) {
    const [resumeTitle, resumeId] = resumeExample.resume;
    const userId = resumeExample.resumeUser.match(/#[1-9]\d*\b/)[0].substr(1);
    const resumeExampleElement = writer.createElement('resumeExample', {
        exampleId: resumeId,
        userId: userId,
    });
    const titleElement = writer.createElement('resumeExampleTitle');
    const descriptionElement = writer.createElement('resumeExampleDescription');
    writer.appendText(resumeTitle, titleElement);
    writer.appendText(`#${resumeId}`, descriptionElement);
    writer.append(titleElement, resumeExampleElement);
    writer.append(descriptionElement, resumeExampleElement);
    return resumeExampleElement;
}
